import { useState, useEffect, useCallback } from 'react';
import { readers } from 'services';
import { skeletonFactory, useHandleRequest } from 'shared';

const readerDummy = skeletonFactory.reader();

export function useReader(id) {
  const [readerData, setReaderData] = useState(id ? readerDummy : {});
  const { request, errorInfo, setErrorInfo } = useHandleRequest();

  useEffect(() => {
    async function getData() {
      await request(async () => {
        const response = await readers.getById(id);
        if (response) {
          setReaderData(response.data || {});
        }
      }, false);
    }
    id && getData();
  }, [request, id]);

  const updateReader = useCallback(
    async reader => {
      await request(async () => {
        setReaderData(reader);
        await readers.update(id, reader);
      });
    },
    [request, id]
  );

  const createReader = useCallback(
    async reader => {
      await request(async () => {
        setReaderData(reader);
        await readers.create(reader);
      });
    },
    [request]
  );

  return {
    reader: readerData,
    errorInfo,
    setErrorInfo,
    setReaderData,
    createReader,
    updateReader
  };
}
